import { render, staticRenderFns } from "./testVaccinationDetail.vue?vue&type=template&id=70cb4165"
import script from "./testVaccinationDetail.vue?vue&type=script&lang=js"
export * from "./testVaccinationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70cb4165')) {
      api.createRecord('70cb4165', component.options)
    } else {
      api.reload('70cb4165', component.options)
    }
    module.hot.accept("./testVaccinationDetail.vue?vue&type=template&id=70cb4165", function () {
      api.rerender('70cb4165', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/testVaccinationDetail.vue"
export default component.exports